import { ComponentBase } from "@tblabs/truffle";


export class H3 extends ComponentBase<HTMLHeadingElement>
{
    constructor(text: string, className?: string)
    {
        super("h3");

        this.Class(className);
        this.Text(text);
    }
}
